import React, { Component } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { NIL } from "uuid";
import classnames from "classnames";
import OrderForm from "./OrderForm";
import OrderAttachmentTab from "./OrderAttachmentTab";
import OrderNoteTab from "./OrderNoteTab";
import OrderTrackingTab from "./OrderTrackingTab";
import OrderNotificationHistoryTab from "./OrderNotificationHistoryTab";
import OrderMessageHistoryTab from "./OrderMessageHistoryTab";
import OrderVerifyTrackingTab from "./OrderVerifyTrackingTab";
import {
  updateOrder,
  getOrderById,
  updateOrderAttachment,
  deleteOrderAttachment,
  getOrderAttachments,
  getOrderNote,
  getOrderTracking,
  getOrderVerifyTracking,
  getOrderNotificationHistory,
  getOrderMessageHistory,
} from "store/actions";

export class OrderDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: NIL,
      activeTab: "1",
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  componentDidMount() {
    const {
      match,
      getOrderById,
      getOrderNote,
      getOrderAttachments,
      getOrderTracking,
      getOrderNotificationHistory,
      getOrderMessageHistory,
    } = this.props;
    const { id } = match.params;

    if (id !== NIL) {
      this.setState({
        id,
      });
      getOrderById(id);
      getOrderNote({ orderId: id });
      getOrderAttachments({ orderId: id });
      getOrderTracking({ orderId: id });
      getOrderNotificationHistory({ orderId: id });
      getOrderMessageHistory({ orderId: id });
    }
  }

  static getDerivedStateFromProps(props, state) {
    const {
      match,
      getOrderById,
      getOrderNote,
      getOrderAttachments,
      getOrderTracking,
      getOrderNotificationHistory,
      getOrderMessageHistory,
    } = props;
    const { id } = match.params;
    if (id !== state.id) {
      getOrderById(id);
      getOrderNote({ orderId: id });
      getOrderTracking({ orderId: id });
      getOrderAttachments({ orderId: id });
      getOrderNotificationHistory({ orderId: id });
      getOrderMessageHistory({ orderId: id });
      return id;
    }
    return null;
  }

  handleUpdateAttachment = attachments => {
    const payload = {
      id: this.state.id,
      attachments,
    };

    this.props.updateOrderAttachment(payload);
  };

  handlePopulateAttachment = () => {
    const { id } = this.state;
    this.props.getOrderAttachments({ orderId: id, pageSize: 12 });
  };
  handlePopulateOrderNote = () => {
    const { id } = this.state;
    this.props.getOrderNote({ orderId: id });
  };

  handlePopulateOrderTracking = () => {
    const { id } = this.state;
    this.props.getOrderTracking({ orderId: id });
  };

  handlePopulateOrderVerifyTracking = () => {
    const { id } = this.state;
    this.props.getOrderVerifyTracking({ orderId: id });
  };
  handlePopulateOrderNotificationHistory = () => {
    const { id } = this.state;
    this.props.getOrderNotificationHistory({ orderId: id });
  };
  handlePopulateOrderMessageHistory = () => {
    const { id } = this.state;
    this.props.getOrderMessageHistory({ orderId: id });
  };

  handleSubmit = order => {
    const { updateOrder, history } = this.props;
    const payload = {
      history,
      data: order,
    };
    updateOrder(payload);
  };

  handleCancel = () => {
    const { history } = this.props;
    history.push("/order");
  };

  handleOnBackToList = () => {
    const { history } = this.props;
    history.push("/order");
  };

  render() {
    const {
      order,
      orderNote,
      orderAttachment,
      orderTracking,
      orderVerifyTracking,
      orderNotificationHistory,
      orderMessageHistory,
    } = this.props;
    const { item, loading } = order;
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Order Detail | JLS Express</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs
              title="Home"
              backLink={"/order"}
              breadcrumbItem="Order Detail"
            />
            <Row>
              <Col lg={12}>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "1",
                      })}
                      onClick={() => {
                        this.toggle("1");
                      }}
                    >
                      General
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "2",
                      })}
                      onClick={() => {
                        this.toggle("2");
                        this.handlePopulateAttachment();
                      }}
                    >
                      Attachments
                      <span className="badge rounded-pill bg-success float-right ms-1 font-size-11">
                        {orderAttachment.itemCount}
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "3",
                      })}
                      onClick={() => {
                        this.toggle("3");
                        this.handlePopulateOrderNote();
                      }}
                    >
                      Notes
                      <span className="badge rounded-pill bg-success float-right ms-1 font-size-11">
                        {orderNote.itemCount}
                      </span>
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "4",
                      })}
                      onClick={() => {
                        this.toggle("4");
                        this.handlePopulateOrderTracking();
                      }}
                    >
                      Tracking
                      <span className="badge rounded-pill bg-success float-right ms-1 font-size-11">
                        {orderTracking.itemCount}
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "5",
                      })}
                      onClick={() => {
                        this.toggle("5");
                        this.handlePopulateOrderVerifyTracking();
                      }}
                    >
                      Verify Tracking
                      <span className="badge rounded-pill bg-success float-right ms-1 font-size-11">
                        {orderVerifyTracking.itemCount}
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "6",
                      })}
                      onClick={() => {
                        this.toggle("6");
                        // this.handlePopulateOrderVerifyTracking();
                      }}
                    >
                      Notification
                      <span className="badge rounded-pill bg-success float-right ms-1 font-size-11">
                        {orderNotificationHistory.itemCount}
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "7",
                      })}
                      onClick={() => {
                        this.toggle("7");
                        // this.handlePopulateOrderVerifyTracking();
                      }}
                    >
                      Message
                      <span className="badge rounded-pill bg-success float-right ms-1 font-size-11">
                        {orderMessageHistory.itemCount}
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    {loading ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-primary m-1"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      item && (
                        <OrderForm
                          id={this.state.id}
                          order={item}
                          onCancel={this.handleCancel}
                          onSubmit={this.handleSubmit}
                        />
                      )
                    )}
                  </TabPane>
                  <TabPane tabId="2">
                    {this.state.id !== NIL && (
                      <OrderAttachmentTab orderId={this.state.id} />
                    )}
                  </TabPane>
                  <TabPane tabId="3">
                    {this.state.id !== NIL && (
                      <OrderNoteTab orderId={this.state.id} />
                    )}
                  </TabPane>
                  <TabPane tabId="4">
                    {this.state.id !== NIL && (
                      <OrderTrackingTab orderId={this.state.id} />
                    )}
                  </TabPane>
                  <TabPane tabId="5">
                    {this.state.id !== NIL && (
                      <OrderVerifyTrackingTab orderId={this.state.id} />
                    )}
                  </TabPane>
                  <TabPane tabId="6">
                    {this.state.id !== NIL && (
                      <OrderNotificationHistoryTab orderId={this.state.id} />
                    )}
                  </TabPane>
                  <TabPane tabId="7">
                    {this.state.id !== NIL && (
                      <OrderMessageHistoryTab orderId={this.state.id} />
                    )}
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

OrderDetail.propTypes = {
  item: PropTypes.object,
  order: PropTypes.object,
  orderNote: PropTypes.object,
  orderAttachment: PropTypes.object,
  orderTracking: PropTypes.object,
  orderVerifyTracking: PropTypes.object,
  orderNotificationHistory: PropTypes.object,
  orderMessageHistory: PropTypes.object,
  loading: PropTypes.bool,
  history: PropTypes.object,
  match: PropTypes.object,
  getOrderById: PropTypes.func,
  updateOrder: PropTypes.func,
  updateOrderAttachment: PropTypes.func,
  deleteOrderAttachment: PropTypes.func,
  getOrderAttachments: PropTypes.func,
  getOrderNote: PropTypes.func,
  getOrderTracking: PropTypes.func,
  getOrderVerifyTracking: PropTypes.func,
  getOrderNotificationHistory: PropTypes.func,
  getOrderMessageHistory: PropTypes.func,
};

const mapStateToProps = ({
  order,
  orderNote,
  orderAttachment,
  orderTracking,
  orderVerifyTracking,
  orderNotificationHistory,
  orderMessageHistory,
}) => {
  return {
    order,
    orderNote,
    orderTracking,
    orderAttachment,
    orderVerifyTracking,
    orderNotificationHistory,
    orderMessageHistory,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    updateOrder,
    getOrderById,
    updateOrderAttachment,
    deleteOrderAttachment,
    getOrderAttachments,
    getOrderNote,
    getOrderTracking,
    getOrderVerifyTracking,
    getOrderNotificationHistory,
    getOrderMessageHistory,
  })(OrderDetail)
);
